/**
 * Checks if a string is valid HTML
 */
export const isValidHtml = (content: string): boolean => {
  // Basic check: does it include HTML tags?
  return /<\/?[a-z][\s\S]*>/i.test(content);
};

/**
 * Creates a safe HTML document for previewing
 */
export const createPreviewHtml = (content: string): string => {
  // Create a basic HTML document if the content doesn't have HTML structure
  if (!content.includes('<!DOCTYPE html>') && !content.includes('<html')) {
    return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>HTML Preview</title>
  <style>
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      line-height: 1.6;
      padding: 20px;
      max-width: 1200px;
      margin: 0 auto;
    }
    pre {
      background-color: #f6f8fa;
      padding: 16px;
      border-radius: 6px;
      overflow: auto;
    }
    code {
      font-family: SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace;
    }
  </style>
</head>
<body>
  ${content}
</body>
</html>
    `;
  }
  
  return content;
};

/**
 * Generates a default filename based on content
 */
export const generateDefaultFilename = (content: string): string => {
  // If it's HTML, use "index.html" or try to extract title
  if (isValidHtml(content)) {
    // Try to extract title from HTML
    const titleMatch = content.match(/<title>(.*?)<\/title>/i);
    if (titleMatch && titleMatch[1]) {
      // Convert title to filename-friendly format
      const filename = titleMatch[1]
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
        
      return `${filename}.html`;
    }
    
    return 'index.html';
  }
  
  // For other code, use a generic filename
  return 'file.txt';
}; 